import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "../getFunctions";
import { CloudFunctionPlexo, CloudFunctionResponsePlexoObtenerInstrumentos } from "@fixeduy/fixedtypes";

export const obtenerInstrumentos = async (): Promise<CloudFunctionResponsePlexoObtenerInstrumentos> => {
    const run = httpsCallable<CloudFunctionPlexo, CloudFunctionResponsePlexoObtenerInstrumentos>(
        cloudFunctions,
        "plexo"
    );
    const result = await run({
        func: "obtenerInstrumentos",
        params: null
    });
    return result.data;
};
